import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { UserDetails } from "@ServerTypes/accounts/accounts.schema";

const initialState: UserDetails = {};

const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    setUserDetails: (_state: UserDetails, action: PayloadAction<UserDetails>) => ({ ...action.payload }),
    updateUserDetails: (state: UserDetails, action: PayloadAction<Partial<UserDetails>>) => ({
      ...state,
      ...action.payload,
    }),
    resetUserDetails: () => initialState,
  },
});

export const { setUserDetails, updateUserDetails, resetUserDetails } = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
